import React from "react";
import Layout from "../../components/web/Layout";
import { Helmet } from "react-helmet";
import { useSelector } from "react-redux";
import Container from "../../components/ui/container/Container";

const TermCondition = () => {
  const setting = useSelector(
    (state) => state.globalState.siteSetting?.policies.terms_and_conditions
  );
  const siteName = useSelector(
    (state) => state.globalState?.siteSetting?.site_settings?.site_name
  );
  return (
    <Layout>
      <Helmet>
        <title>Terms and Condition - {siteName}</title>
      </Helmet>
      <Container className={"bg-white my-5 px-5 rounded"}>
        <div className="mx-5">
          <div dangerouslySetInnerHTML={{ __html: setting }} />
        </div>
      </Container>
    </Layout>
  );
};

export default TermCondition;
